import { render, staticRenderFns } from "./tel.vue?vue&type=template&id=7975ebd6&"
import script from "./js/tel.js?vue&type=script&lang=js&"
export * from "./js/tel.js?vue&type=script&lang=js&"
import style0 from "./tel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports